export enum ROLE_CODE_ENUM {
  PRM = 'Promoter',
  BRC = 'Ticket Scanner',
  KSK = 'Issue tickets in Kiosk',
}
